import { call, put, takeLatest } from "redux-saga/effects";
import {
  validateCustomerNameError,
  validateCustomerNameStart,
  validateCustomerNameSucceded,
} from "./slice";

import { CART_RESOURCE_ROOT } from "Utils/apiUtils";
import { createRequest } from "Utils/requestUtils";

// eslint-disable-next-line @typescript-eslint/explicit-function-return-type
export function* validateLicensePlate({
  payload: { customerRef, customerName },
}: ReturnType<typeof validateCustomerNameStart>) {
  const url = `${CART_RESOURCE_ROOT}/customers/${customerRef}/validateName`;
  try {
    yield call(createRequest, {
      method: "post",
      requestBody: customerName ?? {},
      url,
      open: false,
    });
    yield put(validateCustomerNameSucceded());
  } catch (e) {
    yield put(validateCustomerNameError());
  }
}

export function* validateCustomerNameSaga(): Generator {
  yield takeLatest(validateCustomerNameStart, validateLicensePlate);
}
